// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyCover_container-20waj"};